'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegisterComponent = exports.TWO_FACTOR = exports.DEFAULT = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _masonCanvas = require('../mason-canvas');

var _masonCanvas2 = _interopRequireDefault(_masonCanvas);

var _withConfig = require('../withConfig');

var _withConfig2 = _interopRequireDefault(_withConfig);

var _store = require('../../store');

var _authy = require('../../integrations/authy');

var _authy2 = _interopRequireDefault(_authy);

var _withErrorLogger = require('../withErrorLogger');

var _withErrorLogger2 = _interopRequireDefault(_withErrorLogger);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT = exports.DEFAULT = 'default';
var TWO_FACTOR = exports.TWO_FACTOR = 'twoFactor';

var RegisterComponent = exports.RegisterComponent = function (_Component) {
  _inherits(RegisterComponent, _Component);

  function RegisterComponent(props) {
    _classCallCheck(this, RegisterComponent);

    var _this = _possibleConstructorReturn(this, (RegisterComponent.__proto__ || Object.getPrototypeOf(RegisterComponent)).call(this, props));

    _this.handleReceiveData = _this.handleReceiveData.bind(_this);
    _this.handleSendData = _this.handleSendData.bind(_this);
    _this.state = {
      authyUserId: null,
      configSubpath: DEFAULT,
      user: null
    };
    return _this;
  }

  _createClass(RegisterComponent, [{
    key: 'handleReceiveData',
    value: function handleReceiveData(data) {
      if (this.state.configSubpath === DEFAULT) {
        var user = _lodash2.default.get(data, 'user', data);

        var canPerform2FA = _authy2.default.hasIntegration(this.props.config) && _lodash2.default.has(user, 'authyUserId') && !_lodash2.default.isEmpty(user.authyUserId);

        if (canPerform2FA) {
          _authy2.default.send2FARequest(this.props.config, user.authyUserId).then(function (_ref) {
            var success = _ref.success,
                phone = _ref.phone;

            if (success) {
              window.alert('Please check your phone ' + phone + '.');
            } else {
              window.alert('Sorry, text message failed to send.');
            }
          });

          this.setState({
            authyUserId: user.authyUserId,
            configSubpath: TWO_FACTOR,
            user: data
          });
        } else {
          return this.props.didReceiveData(data);
        }
      } else if (this.state.configSubpath === TWO_FACTOR) {
        if (_lodash2.default.isEqual(data, {
          success: 'true'
        })) {
          // this is a successful 2FA
          // in 2FA state we only callback on success
          // @todo: refactor this not to rely on the data shape
          return this.props.didReceiveData(this.state.user);
        }
      }

      return data;
    }
  }, {
    key: 'handleSendData',
    value: function handleSendData(data) {
      if (this.state.configSubpath === DEFAULT) {
        if (_authy2.default.hasIntegration(this.props.config)) {
          var email = data.email,
              phone = data.phone;

          if (!_lodash2.default.isEmpty(email) && !_lodash2.default.isEmpty(phone)) {
            return _authy2.default.register(this.props.config, {
              email: email,
              phone: phone
            }).then(function (_ref2) {
              var authyId = _ref2.authyId;
              return _extends({}, data, {
                authyUserId: '' + authyId
              });
            });
          }
        }
      }

      return this.props.willSendData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _reactHyperscript2.default)(_masonCanvas2.default, _extends({}, this.props, {
        configSubpath: this.state.configSubpath,
        data: _extends({}, this.props.data, {
          authy: {
            authyUserId: this.state.authyUserId
          }
        }),
        didReceiveData: this.handleReceiveData,
        willSendData: this.handleSendData
      }));
    }
  }]);

  return RegisterComponent;
}(_react.Component);

RegisterComponent.propTypes = {
  config: _propTypes2.default.shape({
    componentId: _propTypes2.default.string,
    data: _propTypes2.default.shape({
      default: _propTypes2.default.shape({
        settings: _propTypes2.default.object,
        tree: _propTypes2.default.object
      })
    })
  }),
  data: _propTypes2.default.object,
  // eslint-disable-line
  didReceiveData: _propTypes2.default.func,
  willSendData: _propTypes2.default.func
};
RegisterComponent.defaultProps = {
  config: {},
  data: {
    data: {}
  },
  didReceiveData: _lodash2.default.identity,
  willSendData: _lodash2.default.identity
};
exports.default = (0, _store.connectWithStore)((0, _withConfig2.default)((0, _withErrorLogger2.default)(RegisterComponent)));